import { gql } from "@apollo/client";
import type { IMagazineEdition } from "types/Magazine.type";

export interface IGetMagazineEditionsPaginatedInput {
  search?: string;
  mine?: boolean;
  limit?: number;
  offset?: number;
}

export interface IGetMagazineEditionsPaginatedResponse {
  items: IMagazineEdition[];
  total: number;
  totalPages: number;
}

const MAGAZINE_EDITION_FIELDS = gql`
  fragment MagazineEditionFields on MagazineEdition {
    id
    title
    canvasEmbed
    previewImage
    createdAt
    updatedAt
    createdById
    canManage
    createdBy {
      id
      name
      lastname
      profileImage
      email
    }
  }
`;

const GET_MAGAZINE_EDITIONS_PAGINATED = gql`
  ${MAGAZINE_EDITION_FIELDS}
  query GetMagazineEditionsPaginated(
    $getMagazineEditionsPaginatedInput: GetMagazineEditionsPaginatedInput!
  ) {
    getMagazineEditionsPaginated(
      getMagazineEditionsPaginatedInput: $getMagazineEditionsPaginatedInput
    ) {
      items {
        ...MagazineEditionFields
      }
      total
      totalPages
    }
  }
`;

const GET_MAGAZINE_EDITION = gql`
  ${MAGAZINE_EDITION_FIELDS}
  query GetMagazineEdition($id: String!) {
    getMagazineEdition(id: $id) {
      ...MagazineEditionFields
    }
  }
`;

const GET_LATEST_MAGAZINE_EDITION = gql`
  ${MAGAZINE_EDITION_FIELDS}
  query GetLatestMagazineEdition {
    getLatestMagazineEdition {
      ...MagazineEditionFields
    }
  }
`;

export default {
  GET_MAGAZINE_EDITIONS_PAGINATED,
  GET_MAGAZINE_EDITION,
  GET_LATEST_MAGAZINE_EDITION,
};
